export default __webpack_public_path__ + "animate-pill-03460ae6f0700a3d91b2a2cee7bb4e78.svg";